'use strict';

var internals = {};

module.exports = function (method) {
  if (method._hoekOnce) {
    return method;
  }

  var once = false;

  var wrapped = function wrapped() {
    if (!once) {
      once = true;
      method.apply(void 0, arguments);
    }
  };

  wrapped._hoekOnce = true;
  return wrapped;
};